var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}],staticStyle:{"height":"100%"}},[_vm._v("\n  "+_vm._s(_vm.title)+"-"+_vm._s(this.$route.query.surgery_id)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767f5d28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Surgery/SecurityCheck/Index.vue
// module id = null
// module chunks = 